module.exports = __webpack_public_path__ + "static/media/67.98bba6a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/67.wav
// module id = qjA2
// module chunks = 0